import mdListingList from '@/modules/md-listing-list/_store';
import mdSearch from '@/modules/md-search/_store';
import mdSearchBar from '@/modules/md-search-bar/_store';
import mdSnapshotSearch from '@/modules/md-snapshot-search/_store';
import mdComplianceCheck from '../modules/md-compliance-check/_store';
import mdHero from '../modules/md-hero/_store';
import mdHouse from '../modules/md-house/_store';
import mdQuickSearch from '../modules/md-quick-search/_store';
import mdTestimonial from '../modules/md-testimonial/_store';
import mdBlog from '../modules/md-blog/_store';
import mdEvaluationBanner from '../modules/md-evaluation-banner/_store';
import mdFeaturedArea from '../modules/md-featured-area/_store';
import mdTeam from '../modules/md-team/_store';
import mdHouseListing from '../modules/md-house-listing/_store';

export const ModuleMap = {
    'md-house': mdHouse,
    'md-hero': mdHero,
    'md-listing-list': mdListingList,
    'md-search-grid-list': mdSearch,
    'md-search-big-map': mdSearch,
    'md-search': mdSearch,
    'md-search-bar': mdSearchBar,
    'md-snapshot-search': mdSnapshotSearch,
    'md-compliance-check': mdComplianceCheck,
    'md-quick-search': mdQuickSearch,
    'md-testimonial': mdTestimonial,
    'md-blog': mdBlog,
    'md-evaluation-banner': mdEvaluationBanner,
    'md-featured-area': mdFeaturedArea,
    'md-team': mdTeam,
    'md-house-listing': mdHouseListing
};
